export const SET_PLAYLIST_DETAIL = 'SET_PLAYLIST_DETAIL';

export const setPlaylistDetail= (playlistDetail) => ({type: SET_PLAYLIST_DETAIL, playlistDetail });

export const setPlaylistDetailEvent = (playlistDetail) => (dispatch) => {
  dispatch({type: SET_PLAYLIST_DETAIL, playlistDetail});
};



// WEBPACK FOOTER //
// ./src/actions/musica/playlistdetails.js